import React, { useEffect, useState } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import '../index.scss';
import ReferBusiness from 'featureLib/ReferBusiness';
import NextSteps from 'featureLib/NextSteps';
import ExploreProducts from 'featureLib/ExploreProducts';
import { getProductDisplayName, getProductType, META_TAGS, PRODUCT_NAME, PRODUCT_TYPE } from 'common/constants/app.constants';
import { getFromSessionStorage, navigateTo, setMetaTags, trackAnalytics } from 'common/utils/app.utils';
import { MODULE_ID } from 'home/common/constants/constants';
import config from 'config/config';

export const UnAuthThanksPage = (props: any) => {
  const { userType, isMultiSite, product, leadId } = props;
  const currentProduct = product || getProductType();
  const productName = getProductDisplayName(currentProduct);
  const [productCheck, setProductCheck] = useState(getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN ? PRODUCT_TYPE.VPN : 'Dedicated Internet');
  const [showsubmitSuccess, setshowsubmitSuccess] = useState(false);

  const getMessageBody = () => {
    if (userType === 'KAM') {
      return `Your booking order for the Airtel ${productCheck} Plan has been approved. An e-mail has been sent to customer along with the pricing quotation. Booking ordernumber: ${leadId}`;
    }
    if (userType === 'ENTERPRISE') {
      return `Your booking order for the ${isMultiSite ? 'multiple' : ''} Airtel ${productCheck} has been submitted. An e-mail has been sent to you along with the pricing
      quotation. Booking order number: ${leadId}`;
    }

    return `Your requirement has been successfully submitted for Dedicated Internet.`;
  };

  useEffect(() => {
    setMetaTags(META_TAGS.B2B_THANK_YOU);
    trackAnalytics({
      eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|thank you`,
      prop21: leadId,
      eVar5 : 'ql_lead_created'
  })
  }, []);

  return (
    <div className="thanks_page">
      <div className="container">
        {showsubmitSuccess && (
          <div className="network-coverage">
            <div className="coverageContent greenshade">
              <div className="checkIcon">
                <i className="material-icons">check_circle</i>
              </div>
              <p>
                <span>Thank you for sharing a business reference.</span> We will be contacting the referred person soon. Please share any other reference if you have.
              </p>
              <div className="crossIcon">
                <i className="material-icons">clear</i>
              </div>
            </div>
          </div>
        )}
        <div className="thanks_wrapper">
          <div className="thanks_left">
            <div className="thanks-content">
              <div className="head-title">
                <div className="checkmark_box">
                  <div className="check"></div>
                </div>
                <h2>{'Thank you for choosing Airtel!'}</h2>
              </div>
              <p className="title-subtext">
                Request Number: <span>{leadId}</span> <br />
                {getMessageBody()}
              </p>
              {/* <Button className="redirect_btn" onClick={() => navigateTo(config.kamTrackLeadPage)} displayName="Track Request" buttonClass="btn_outline" variant="outlinebtn" /> */}
            </div>
          </div>
          <div className="thanks_right">
            <NextSteps />
          </div>
        </div>
        <div className="explore_section">
          <h2 className="explore_head">Explore Other Products</h2>
          <ExploreProducts />
        </div>
        <div className="referBusiness">
          <ReferBusiness setshowsubmitSuccess={setshowsubmitSuccess} />
        </div>
      </div>
    </div>
  );
};

export default UnAuthThanksPage;
